export default __webpack_public_path__ + "static/media/Roboto-Bold.f80816a5.ttf";